import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionService } from './session.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AfastamentoService {
  private urlServer = environment.URL_API;
  private readonly apiUrl = '/afastamento/afastamento-militar';
  constructor(private http: HttpClient, private sessionService: SessionService) {}

  enviarAfastamento(payload: { dataAfastamento: string }) {

    const token = this.sessionService.token

     const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    return this.http.post(this.urlServer + this.apiUrl, payload, { headers });
  }

  verificarAfastamento(matricula: string, idOrgao: number) {
    const token = this.sessionService.token
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
    // Mesma API do ambiente do build (antes estava fixa em hml, inclusive em produção).
    const url = `${this.urlServer}/afastamento/verificar-afastamento/${matricula}/orgao/${idOrgao}`;
    return this.http.get(url, { headers });
  }
}
